var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "Icon / InfoCircleFilled" } }, [
        _c("path", {
          attrs: {
            id: "Vector",
            d: "M8 1.5C4.13438 1.5 1 4.63438 1 8.5C1 12.3656 4.13438 15.5 8 15.5C11.8656 15.5 15 12.3656 15 8.5C15 4.63438 11.8656 1.5 8 1.5ZM8.5 11.875C8.5 11.9438 8.44375 12 8.375 12H7.625C7.55625 12 7.5 11.9438 7.5 11.875V7.625C7.5 7.55625 7.55625 7.5 7.625 7.5H8.375C8.44375 7.5 8.5 7.55625 8.5 7.625V11.875ZM8 6.5C7.80374 6.49599 7.61687 6.41522 7.47948 6.275C7.3421 6.13478 7.26515 5.9463 7.26515 5.75C7.26515 5.5537 7.3421 5.36522 7.47948 5.225C7.61687 5.08478 7.80374 5.00401 8 5C8.19626 5.00401 8.38313 5.08478 8.52052 5.225C8.6579 5.36522 8.73485 5.5537 8.73485 5.75C8.73485 5.9463 8.6579 6.13478 8.52052 6.275C8.38313 6.41522 8.19626 6.49599 8 6.5Z",
            fill: "#070823",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }